import { render, staticRenderFns } from "./wtGalleryAsset.component.vue?vue&type=template&id=787b3cbb&"
import script from "./wtGalleryAsset.component.vue?vue&type=script&lang=js&"
export * from "./wtGalleryAsset.component.vue?vue&type=script&lang=js&"
import style0 from "./wtGalleryAsset.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports